import { HttpInterceptorFn } from '@angular/common/http';

export const SKIP_TOKEN_HEADER_KEY = 'Skip-Token';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // Check and remove the 'Skip-Token' header if it exists
  if (req.headers.has(SKIP_TOKEN_HEADER_KEY)) {
    const headers = req.headers.delete(SKIP_TOKEN_HEADER_KEY);
    req = req.clone({ headers });
  }

  // Proceed with the request
  return next(req);
};
